import { Animator } from '../Animator/Animator';
import { Easing, Group, Tween } from '@tweenjs/tween.js';
import { areVectorsEqual } from '../../utils/geomUtils';
const DEFAULT_EASING_FUNCTION = Easing.Sinusoidal.Out;
const DEFAULT_DURATION = 500;
export class CameraAnimator extends Animator {
    constructor(camera, cameraControls) {
        super();
        this.camera = camera;
        this.controls = cameraControls;
    }
    tweenCameraTo(position, up, target, config = {}) {
        const { onStep, easing = DEFAULT_EASING_FUNCTION, duration = DEFAULT_DURATION, afterEnd, zoom, } = config;
        const tweens = [];
        if (!areVectorsEqual(this.camera.position, position)) {
            tweens.push(new Tween(this.camera.position).to(position, duration).easing(easing).start());
        }
        if (!areVectorsEqual(this.camera.up, up)) {
            tweens.push(new Tween(this.camera.up).to(up, duration).easing(easing).start());
        }
        if (!areVectorsEqual(this.controls.target, target)) {
            tweens.push(new Tween(this.controls.target).to(target, duration).easing(easing).start());
        }
        if (zoom !== undefined && this.camera.zoom !== undefined && Math.abs(this.camera.zoom - zoom) > 0.001) {
            const zoomObj = { zoom: this.camera.zoom };
            tweens.push(new Tween(zoomObj)
                .to({ zoom }, duration)
                .easing(easing)
                .onUpdate(() => {
                var _a, _b;
                if (this.camera.zoom !== undefined) {
                    this.camera.zoom = zoomObj.zoom;
                    (_b = (_a = this.camera).updateProjectionMatrix) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
            })
                .start());
        }
        const tweenGroup = new Group(...tweens);
        this.animate({
            timing: (t) => t,
            duration: duration,
            draw: (t) => {
                tweenGroup.update();
                onStep === null || onStep === void 0 ? void 0 : onStep(t);
            },
            afterEnd,
        });
    }
}
